import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  status: 'idle',
  selectedChannel: JSON.parse(localStorage.getItem('selectedChannel')) || {},
  selectBoxData: JSON.parse(localStorage.getItem('selectBoxData')) || {},
  channelsLoading: false,
};

const channels = createSlice({
  name: 'channels',
  initialState,
  reducers: {
    setSelectedChannel: (state, action) => {
      state.selectedChannel = action.payload;
      localStorage.setItem('selectedChannel', JSON.stringify(action.payload));
    },

    setSelectBoxData: (state, action) => {
      state.selectBoxData = action.payload;
      localStorage.setItem('selectBoxData', JSON.stringify(action.payload));
    },
    setChannelsLoading: (state, action) => {
      state.channelsLoading = action.payload;
    },
  },
});

export const { setSelectedChannel, setSelectBoxData, setChannelsLoading } = channels.actions;

export default channels.reducer;
